import { get, isEmpty } from 'lodash-es'
import CONSTANTS from '../constants'
import GETTER_TYPES from '../getter-types'
import { REQUEST_STATE } from '@/js/plugins/store/modules/aimeos/constants'
import { CONSTANTS as ADDRESS_CONSTANTS } from '@/js/helper/aimeos-customer-address-constants'

export const getBlockingreasonGetters = MUTATION_TYPES => ({
  [GETTER_TYPES.BLOCKINGREASONS_PROMISE]: state =>
    get(state, MUTATION_TYPES.BLOCKINGREASONS.promiseKey),
  [GETTER_TYPES.BLOCKINGREASONS_DATA]: state => get(state, MUTATION_TYPES.BLOCKINGREASONS.dataKey),
  [GETTER_TYPES.BLOCKINGREASONS_LIST]: state => {
    return get(
      state,
      [
        MUTATION_TYPES.BLOCKINGREASONS.dataKey,
        CONSTANTS.BLOCKINGREASON_DATA_KEYS.BLOCKINGREASON_ARRAY,
      ],
      [],
    )
  },
  [GETTER_TYPES.ADDRESSES_WITH_BLOCKINGREASONS]: (state, getters) => {
    const data = []
    const blockingreasonList = get(
      state,
      [
        MUTATION_TYPES.BLOCKINGREASONS.dataKey,
        CONSTANTS.BLOCKINGREASON_DATA_KEYS.BLOCKINGREASON_ARRAY,
      ],
      [],
    )
    const customerAddresses = getters[GETTER_TYPES.CUSTOMER_DELIVERY_ADDRESSES]

    blockingreasonList?.map(item => {
      // if item has any blockingreasons in array, search for address in customerAddresses
      if (!isEmpty(item.blockingReasons)) {
        // Trim leading zeros from customer ID
        const sapAddressID = item.Customer?.replace(/\b0+/g, '')
        const salesOrganization = item?.SalesOrg
        const blockingReasons = item?.blockingReasons
        // filter customer addresses for matching address for sapId
        customerAddresses?.map(address => {
          if (address.attributes[ADDRESS_CONSTANTS.ATTRIBUTE.SAP_ADDRESS_ID] === sapAddressID) {
            data.push({
              sapAddressID,
              salesOrganization,
              blockingReasons,
              id: address.attributes[ADDRESS_CONSTANTS.ATTRIBUTE.ID],
              name: address.attributes[ADDRESS_CONSTANTS.ATTRIBUTE.COMPANY],
              zip: address.attributes[ADDRESS_CONSTANTS.ATTRIBUTE.POSTAL],
              city: address.attributes[ADDRESS_CONSTANTS.ATTRIBUTE.CITY],
              street: address.attributes[ADDRESS_CONSTANTS.ATTRIBUTE.ADDRESS1],
            })
          }
        })
      }
    })

    return data
  },
  [GETTER_TYPES.BLOCKINGREASONS_PENDING]: state =>
    get(state, MUTATION_TYPES.BLOCKINGREASONS.stateKey, REQUEST_STATE.STATE_FAILURE) ===
    REQUEST_STATE.STATE_PENDING,
})
